import {
    Configuration,
    IPublicClientApplication,
    PublicClientApplication,
    RedirectRequest,
    SilentRequest,
} from '@azure/msal-browser';
import type {AuthConfig, LoginRedirectParams} from '../types/composables/useMsal';

export default () => {
    return {
        initMsalInstance,
        redirectLoginWithB2C,
        checkIfUserIsLoggedInB2C,
    };
};

async function redirectLoginWithB2C({
    msalInstance,
    locale,
    disableKmsi,
    loginHint = null,
}: LoginRedirectParams): Promise<void> {
    const loginRequest: RedirectRequest = {
        scopes: ['openid', 'profile'],
        loginHint: loginHint ?? undefined,
        extraQueryParameters: {
            disable_kmsi: disableKmsi.toString(),
            ui_locales: locale,
        },
    };
    await msalInstance.loginRedirect(loginRequest);
}

async function checkIfUserIsLoggedInB2C(msalInstance: IPublicClientApplication): Promise<boolean> {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        return true;
    }

    const silentRequest: SilentRequest = {
        scopes: ['openid', 'profile'],
    };

    try {
        await msalInstance.acquireTokenSilent(silentRequest);
        return true;
    } catch {
        return false;
    }
}

async function initMsalInstance(authConfig: AuthConfig): Promise<PublicClientApplication> {
    const msalConfig = getMsalConfig(authConfig);
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    return msalInstance;
}

function getMsalConfig(authConfig: AuthConfig): Configuration {
    return {
        auth: authConfig,
        cache: {
            cacheLocation: 'sessionStorage',
            temporaryCacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
            claimsBasedCachingEnabled: true,
        },
        system: {
            windowHashTimeout: 60000,
            iframeHashTimeout: 6000,
            loadFrameTimeout: 0,
            asyncPopups: false,
        },
        telemetry: {
            application: {
                appName: 'FleetVision',
                appVersion: '1.0.0',
            },
        },
    };
}
